import React from 'react';

import Button from '../Button/Button';

import styles from './BrowseNotification.module.scss';

const BrowseNotification = ({ img, isVisible, ...props }) => (
  <Button variant={isVisible ? 'notification-focus' : 'notification'} {...props}>
    <img src={img} alt="bell" className={styles.bellIcon} />
  </Button>
);

export default BrowseNotification;
